import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";

export default function Refresh() {
    const { connectedAccountId } = useParams();
    const [accountLinkCreatePending, setAccountLinkCreatePending] = useState(false);
    const [error, setError] = useState(false);

    useEffect(() => {
        if (connectedAccountId) {
            setAccountLinkCreatePending(true);
            fetch(`${process.env.REACT_APP_API_BASE_URL}/api/stripe/account_link`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    Authorization: `Bearer ${sessionStorage.getItem('accessToken')}`, // Use session storage
                },
                body: JSON.stringify({
                    account: connectedAccountId,
                }),
            })
                .then((response) => response.json())
                .then((json) => {
                    setAccountLinkCreatePending(false);

                    const { url, error } = json;

                    if (url) {
                        window.location.href = url; // Redirect to Stripe onboarding
                    }

                    if (error) {
                        setError(true);
                    }
                })
                .catch(() => setError(true));
        }
    }, [connectedAccountId]);

    return (
        <div className="container">
            <div className="banner">
                <h2>Interim</h2>
            </div>
            <div className="content">
                <h2>Add information to start accepting money</h2>
                <p>Interim partners with Stripe to help you receive payments securely.</p>
                {error && <p className="error">Something went wrong!</p>}
            </div>
            <div className="dev-callout">
                {connectedAccountId && <p>Your connected account ID is: <code className="bold">{connectedAccountId}</code></p>}
                {accountLinkCreatePending && <p>Creating a new Account Link...</p>}
            </div>
        </div>
    );
}